const faqItems = [
  {
    id: 1,
    q: '羞羞漫画收费吗？',
    a: '完全免费！羞羞漫画所有韩漫、日漫、国漫作品均支持免费在线阅读，无需付费订阅，也无需观看强制广告。我们致力于为漫画爱好者提供纯净、高质量的免费阅读体验。',
  },
  {
    id: 2,
    q: '什么是下拉式阅读？和传统翻页有什么区别？',
    a: '下拉式阅读是羞羞漫画独创的阅读模式。您只需向上滑动屏幕，内容就会自动加载，无需点击翻页按钮。相比传统翻页，下拉式阅读更流畅、更沉浸，特别适合手机端阅读长篇漫画。',
  },
  {
    id: 3,
    q: '漫画更新频率是怎样的？',
    a: '羞羞漫画每日更新200+话内容，涵盖韩漫、日漫、国漫全品类。热门连载作品通常保持每周至少更新一话的节奏，部分热门作品可达到日更频率。关注作品后还能收到更新提醒。',
  },
  {
    id: 4,
    q: '支持哪些平台和设备？',
    a: '羞羞漫画支持网页端、Android和iOS全平台阅读。您可以直接在浏览器中访问，也可以下载羞羞漫画APP获得更好的阅读体验。所有平台数据实时同步，阅读进度自动保存。',
  },
  {
    id: 5,
    q: '如何找到我想看的漫画？',
    a: '您可以通过首页的分类索引按韩漫、日漫、国漫或题材类型浏览，也可以在热门排行榜中发现大家都在追的热门作品。首页的精选推荐和焦点专题也会定期更新编辑精选内容。',
  },
  {
    id: 6,
    q: '漫画加载慢或无法显示怎么办？',
    a: '如果遇到加载问题，建议先检查网络连接，或尝试切换Wi-Fi与移动数据。您也可以清除浏览器缓存后重试。如问题持续，欢迎通过联系我们页面反馈，我们会第一时间处理。',
  },
];

export default function Faq() {
  return (
    <section id="faq" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex items-center gap-3 mb-3">
          <div className="w-10 h-10 rounded-full bg-secondary-100 flex items-center justify-center">
            <i className="ri-question-answer-line text-secondary-500 text-xl"></i>
          </div>
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">常见问题</h2>
        </div>
        <p className="text-foreground-500 text-sm md:text-base mb-8 ml-[52px]">关于羞羞漫画，你可能想了解的一切</p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-5xl mx-auto">
          {faqItems.map((item) => (
            <div
              key={item.id}
              className="p-5 rounded-2xl bg-background-50 border border-background-200/70 hover:border-secondary-200 transition-all duration-200 cursor-pointer"
            >
              <h3 className="text-sm font-semibold text-foreground-800 mb-2 flex items-start gap-2">
                <span className="text-secondary-500 flex-shrink-0 mt-0.5">Q:</span>
                {item.q}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed pl-5">{item.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}